module.exports = __webpack_public_path__ + "static/media/castel-from-logis.aad6b584.png";